export enum MuModalEvidencesFlags {
  LOADER = 999,
}
